import * as React from "react";

interface FileIconProps {
    className?: string;
    onClick?: () => void;
}

export function FileIcon(props: FileIconProps) {
    return (
        <div {...props}>
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="40" height="40" rx="8" fill="#F2F2F2" />
                <g clipPath="url(#clip0_8625_2400)">
                    <path
                        d="M25.5594 15.0625L22.9375 12.4406C22.6562 12.1594 22.275 12 21.8781 12H15.5C14.6719 12.0031 14 12.675 14 13.5031V26.5031C14 27.3313 14.6719 28.0031 15.5 28.0031H24.5C25.3281 28.0031 26 27.3313 26 26.5031V16.125C26 15.7281 25.8406 15.3438 25.5594 15.0625ZM24.3781 16.0031H22V13.625L24.3781 16.0031ZM15.5 26.5031V13.5031H20.5V16.7531C20.5 17.1688 20.8344 17.5031 21.25 17.5031H24.5V26.5031H15.5Z"
                        fill="#333333"
                    />
                    <path
                        d="M25.5594 15.0625L22.9375 12.4406C22.6562 12.1594 22.275 12 21.8781 12H15.5C14.6719 12.0031 14 12.675 14 13.5031V26.5031C14 27.3313 14.6719 28.0031 15.5 28.0031H24.5C25.3281 28.0031 26 27.3313 26 26.5031V16.125C26 15.7281 25.8406 15.3438 25.5594 15.0625ZM24.3781 16.0031H22V13.625L24.3781 16.0031ZM15.5 26.5031V13.5031H20.5V16.7531C20.5 17.1688 20.8344 17.5031 21.25 17.5031H24.5V26.5031H15.5Z"
                        fill="white"
                        fillOpacity="0.25"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_8625_2400">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(12 12)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
}
